import { mapGetters, mapMutations } from 'vuex'
import {
  ConsentOptionsEnum,
  ConsentStateEnum,
  CookieConsentNamesEnum
} from '../../../../vue/cookies/store/cookiesModule'
import { getCookie, setCookie } from '../../../js/es6/utilities/cookie-access'

export default {
  computed: {
    ...mapGetters('cookies', [
      'getAdStorage',
      'getAnalyticsStorage',
      'getFunctionalityStorage',
      'getPersonalizationStorage',
      'getCookieConsentStatus'
    ])
  },
  created () {
    this.initializeGTAGManagerCookieConsent()
  },
  mounted () {
    if (!this.getCookieConsentStatus) {
      this.$root.$emit('cookies-modal-open')
    }
  },
  methods: {
    ...mapMutations('cookies', [
      'updateConsentStateByName'
    ]),
    initializeGTAGManagerCookieConsent () {
      if (!this.getCookieConsentStatus) {
        this.initializeDefaultState()
        return
      }
      this.initializeStateFromCookies()
    },
    initializeDefaultState () {
      window.dataLayer = window.dataLayer || []
      function gtag () { window.dataLayer.push(arguments) }
      this.setCookieDefaultValuesForConsent().then(() => {
        gtag('consent', ConsentStateEnum.DEFAULT, {
          ad_storage: this.getAdStorage.defaultValue,
          analytics_storage: this.getAnalyticsStorage.defaultValue,
          functionality_storage: this.getFunctionalityStorage.defaultValue,
          personalization_storage: this.getPersonalizationStorage.defaultValue
          // security_storage is not supported for our platform
        })
      })
    },
    initializeStateFromCookies () {
      window.dataLayer = window.dataLayer || []
      function gtag () { window.dataLayer.push(arguments) }
      this.setAllDefaultConsents().then(() => {
        gtag('consent', ConsentStateEnum.DEFAULT, {
          ad_storage: getCookie(CookieConsentNamesEnum.CONSENT_AD_STORAGE),
          analytics_storage: getCookie(CookieConsentNamesEnum.CONSENT_ANALYTICS_STORAGE),
          functionality_storage: getCookie(CookieConsentNamesEnum.CONSENT_FUNCTIONALITY_STORAGE),
          personalization_storage: getCookie(CookieConsentNamesEnum.CONSENT_PERSONALIZATION_STORAGE)
          // security_storage is not supported for our platform
        })
      })
    },
    async setAllDefaultConsents () {
      this.updateConsentStateByName({
        consentName: ConsentOptionsEnum.CONSENT_AD_STORAGE,
        newConsentState: { value: getCookie(CookieConsentNamesEnum.CONSENT_AD_STORAGE) }
      })
      this.updateConsentStateByName({
        consentName: ConsentOptionsEnum.CONSENT_ANALYTICS_STORAGE,
        newConsentState: { value: getCookie(CookieConsentNamesEnum.CONSENT_ANALYTICS_STORAGE) }
      })
      this.updateConsentStateByName({
        consentName: ConsentOptionsEnum.CONSENT_FUNCTIONALITY_STORAGE,
        newConsentState: { value: getCookie(CookieConsentNamesEnum.CONSENT_FUNCTIONALITY_STORAGE) }
      })
      this.updateConsentStateByName({
        consentName: ConsentOptionsEnum.CONSENT_PERSONALIZATION_STORAGE,
        newConsentState: { value: getCookie(CookieConsentNamesEnum.CONSENT_PERSONALIZATION_STORAGE) }
      })
    },
    async setCookieDefaultValuesForConsent () {
      await Promise.all([
        setCookie(
          CookieConsentNamesEnum.CONSENT_AD_STORAGE,
          this.getAdStorage.defaultValue,
          this.getAdStorage.validForDays
        ),
        setCookie(
          CookieConsentNamesEnum.CONSENT_ANALYTICS_STORAGE,
          this.getAnalyticsStorage.defaultValue,
          this.getAnalyticsStorage.validForDays
        ),
        setCookie(
          CookieConsentNamesEnum.CONSENT_FUNCTIONALITY_STORAGE,
          this.getFunctionalityStorage.defaultValue,
          this.getFunctionalityStorage.validForDays
        ),
        setCookie(
          CookieConsentNamesEnum.CONSENT_PERSONALIZATION_STORAGE,
          this.getPersonalizationStorage.defaultValue,
          this.getPersonalizationStorage.validForDays
        )
      ])
    }
  }
}
